import { useContext } from 'react';
import { FeatureFlagContext } from './FeatureFlagProvider';

/**
 * Hook to check if a feature flag is enabled.
 * Returns false if the context is not available (e.g., outside provider).
 */
export function useFeatureFlag(name: string): boolean {
  const context = useContext(FeatureFlagContext);
  if (!context) return false;
  return context.flags[name] ?? false;
}

/**
 * Check if multiple flags are all enabled.
 */
export function useAllFlags(names: string[]): boolean {
  const context = useContext(FeatureFlagContext);
  if (!context) return false;
  return names.every((name) => context.flags[name] ?? false);
}

/**
 * Check if any of the given flags is enabled.
 */
export function useAnyFlag(names: string[]): boolean {
  const context = useContext(FeatureFlagContext);
  if (!context) return false;
  return names.some((name) => context.flags[name] ?? false);
}
